import { MessageMetadata } from './ChatFramework.types';

export type PrePromptConditions = {hasAction:boolean, hasSupport: boolean}
export const conditionHelper = ({ hasAction, hasSupport }:PrePromptConditions) => (source:PrePromptConditions) => source.hasAction === hasAction && source.hasSupport === hasSupport;

export function isPromise<T> (variable: any): variable is Promise<T> {
  return !!variable && typeof variable === 'object' && typeof variable.then === 'function';
}

export function toArr<T> (value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}
export const noop = () => void 0;

export function contains<T> (type: 'all' | 'any', haystack: Array<T>, ...check: Array<T>): boolean {
  const haystackSet = new Set(haystack); // Convert haystack to a Set for faster lookups

  if (type === 'all') {
    // Check if every element in check is in the haystackSet
    return check.every(element => haystackSet.has(element));
  } else {
    // Check if any element in check is in the haystackSet
    return check.some(element => haystackSet.has(element));
  }
}

export function metaFilter (tags?: MessageMetadata[]) {
  let result = !!tags?.length;
  return {
    any (...checks: MessageMetadata[]) {
      if (!result) return this;
      result = result && contains('any', tags || [], ...checks);
      return this;
    },
    all (...checks: MessageMetadata[]) {
      if (!result) return this;
      result = result && contains('all', tags || [], ...checks);
      return this;
    },
    get () {
      return result;
    },
  };
}
